import {createSelector} from 'reselect';
import {getFeedbacks, getValueUser, getValueTeam, getValueAuthor, getDerection} from './selectors';

import {sortProfilesByName} from 'feedback-system/utils/sortProfilesByName';

import {Feedback} from '../type';

/* eslint max-params: ["error", 4] */
export default createSelector(
    getFeedbacks,
    getValueUser,
    getValueTeam,
    getValueAuthor,
    getDerection,
    // eslint-disable-next-line max-params
    (feedbacks, user, team, author, derection) => {
        const total = feedbacks.reduce((memo: Feedback[], feedback: Feedback) => {
            const recipient = feedback.profile.firstName + ' '
                + feedback.profile.lastName;
            const recipientTeam = feedback.profile.mainTeam;
            const feedbacksAll = feedback.feedbacks.map((element: Feedback) => {
                return {
                    ...element,
                    recipient,
                    recipientTeam
                };
            });
            return memo.concat(feedbacksAll);
        }, [])
            .filter((feedback: Feedback) => feedback.recipient.toLowerCase().includes(user.toLowerCase()))
            .filter((feedback: Feedback) => `${feedback.author.firstName} ${feedback.author.lastName}`
                .toLowerCase().includes(author.toLowerCase()))
            .filter((feedback: Feedback) => feedback.recipientTeam
                .toLowerCase().includes(team.toLowerCase()))
            .sort((a: Feedback, b: Feedback) => {
                return sortProfilesByName(a.author, b.author);
            })
            .sort((a: Feedback, b: Feedback) => {

                const ratingA = a.feedbackData.RATING;
                const ratingB = b.feedbackData.RATING;

                if (ratingA === null || ratingA === undefined) {
                    return 1;
                }

                if (ratingB === null || ratingB === undefined) {
                    return -1;
                }

                switch (derection) {
                    case 'asc':
                        return Number(ratingB) - Number(ratingA);
                    case 'desc':
                        return Number(ratingA) - Number(ratingB);
                    default:
                        return 0;
                }

            });

        const ratingEmpty = total.filter((feedback: Feedback) => feedback.feedbackData.RATING === null);
        const rating = total.filter((feedback: Feedback) => feedback.feedbackData.RATING !== null);
        return [...rating, ...ratingEmpty];
    }
);
